import { t } from "@travily/i18n";
import { WizardTextField } from "@ui/components/WizardTextField";
import type { ListingFieldCopy, ListingFieldProps, ListingType } from "./types";

const COLOR = "green" as const;

/**
 * Soft length recommendation. Past it the field reveals the muted "gets
 * shortened on cards" hint and its character count; it never blocks input —
 * the hard cap is the Listing model's validation. Derived from the narrowest
 * card's measured fit.
 */
export const TITLE_RECOMMENDED_LENGTH = 24;

// i18n-tasks-use t('web.listings.fields.title.product.heading')
// i18n-tasks-use t('web.listings.fields.title.product.helper')
// i18n-tasks-use t('web.listings.fields.title.product.placeholder')
// i18n-tasks-use t('web.listings.fields.title.service.heading')
// i18n-tasks-use t('web.listings.fields.title.service.helper')
// i18n-tasks-use t('web.listings.fields.title.service.placeholder')

export function titleFieldCopy(listingType: ListingType): ListingFieldCopy {
  return {
    heading: t(`web.listings.fields.title.${listingType}.heading`),
    helper: t(`web.listings.fields.title.${listingType}.helper`),
  };
}

export function TitleField({ error, listingType, onBlur, onChange, onKeyDown, value }: ListingFieldProps) {
  const { heading } = titleFieldCopy(listingType);

  return (
    <WizardTextField
      aria-label={heading}
      autoFocus
      color={COLOR}
      errorMessage={error}
      fitHintMessage={t("web.listings.fields.title.fit_hint")}
      isInvalid={Boolean(error)}
      isLabelHidden
      label={heading}
      onBlur={onBlur}
      onChange={onChange}
      onKeyDown={onKeyDown}
      placeholder={t(`web.listings.fields.title.${listingType}.placeholder`)}
      recommendedLength={TITLE_RECOMMENDED_LENGTH}
      showCharacterCount
      value={value}
    />
  );
}
